<template>
  <b-container fluid
               class="disclosure-template-container">
    <!-- Spinner -->
    <loading :active="loading"
             :is-full-page="false"
             :z-index="1000"/>
    <!-- /Spinner -->

    <!-- Form and Table of Contents -->
    <div>
      <disclosure-template-form ref="template-from"
                                :template="template"/>
    </div>
    <!-- /Form and Table of Contents -->

    <!-- Buttons -->
    <div class="btn-container">
      <div class="btn-wrap">
        <esg-base-button @click="close"
                         variant="secondary">닫기
        </esg-base-button>
        <esg-base-button @click="submit"
                         variant="primary">생성
        </esg-base-button>
      </div>
    </div>
    <!-- /Buttons -->
  </b-container>
</template>

<script>
import EsgBaseButton from "@/components/esg/base/EsgBaseButton.vue";
import DisclosureTemplateForm from "@/components/esg/6. ESG 공시보고/6.1. 보고서 항목 관리/DisclosureTemplateForm.vue";

export default {
  components: { DisclosureTemplateForm, EsgBaseButton },
  data() {
    return {
      loading: false,
      template: {
        title: '',
        description: '',
        tableOfContents: [],
      },
    }
  },
  methods: {
    async submit() {
      // Validate the disclosure template form
      if (!await this.$refs['template-from'].validateForm()) {
        return;
      }

      this.preprocess(this.template.tableOfContents);

      try {
        this.loading = true;

        await axios.post('esg/disclosure/disclosure-templates', this.template, {
          headers: { Authorization: accessToken() }
        });

        await this.showMessage('목차가 생성되었습니다.');

        this.pushRoute('/esg/disclosure-templates')
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    preprocess(root) {
      if (typeof root === "object" && root.children) {
        root = root.children;
      }

      root.forEach((child, index) => {
        // Remove parent field to remove circular reference (if not, causes an error when converting to JSON)
        delete child.parent;

        // Remove UUID (if not, causes an error when converting to JSON)
        delete child.id;

        // Set order among its siblings
        child.order = index;
        this.preprocess(child);
      });
    },
    close() {
      this.pushRoute('/esg/disclosure-templates');
    },
  },
}
</script>

<style scoped>
.disclosure-template-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;
}
</style>
